import { useRef, useState } from "react";
import { PopupOuter, PopupHeader, InputRow, InputGroup, PopupInput } from "../styles/Layouts";
import { FiX } from "react-icons/fi";
import { PopupForm } from "../styles/Forms";
import { ReserveBtn } from "../styles/Buttons";
// import emailjs from "@emailjs/browser";

const DetailsPopup = ({ product, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [date, setDate] = useState("");

  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    const [selectedDate, selectedTime] = date.split("_");
    const orderID = "RES-" + Date.now().toString(36).toUpperCase();

    const reservationDetails = {
      order_id: orderID,
      name: name,
      email: email,
      phoneNumber: phoneNumber,
      date: selectedDate,
      time: selectedTime,
      title: product.title,
      price: product.price,
    };

    localStorage.setItem("pendingReservation", JSON.stringify(reservationDetails));
    console.log("Pending reservation: ", localStorage.getItem("pendingReservation"));
    window.location.assign(process.env.REACT_APP_STRIPE_PAYMENT_LINK);

    //below: only for testing
    // emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, reservationDetails, process.env.REACT_APP_PUBLIC_KEY).then(
    //   () => {
    //     console.log("Email sent successfully!");
    //     window.location.assign(process.env.REACT_APP_STRIPE_PAYMENT_LINK);
    //   },
    //   (error) => {
    //     console.log("Failed...", error.text);
    //   },
    // );
  };

  return (
    <PopupOuter>
      <PopupHeader>
        <h4 style={{ padding: "0 3vw" }}>Reserve: {product.title}</h4>
        <button onClick={onClose}>
          <FiX />
        </button>
      </PopupHeader>
      <PopupForm id="reservation-form" ref={form} onSubmit={handleSubmit}>
        <InputRow>
          <InputGroup>
            <label>Name:</label>
            <PopupInput type="text" value={name} id="name" name="name" onChange={(e) => setName(e.target.value)} required />
          </InputGroup>

          <InputGroup>
            <label>Email:</label>
            <PopupInput type="email" value={email} id="email" name="email" onChange={(e) => setEmail(e.target.value)} required />
          </InputGroup>
        </InputRow>

        <InputRow>
          <InputGroup>
            <label>Contact Number:</label>
            <PopupInput type="tel" value={phoneNumber} id="phoneNumber" name="phone-number" onChange={(e) => setPhoneNumber(e.target.value)} required />
          </InputGroup>

          <InputGroup>
            <label>Date & Time:</label>
            <PopupInput as="select" value={date} id="date" name="date" onChange={(e) => setDate(e.target.value)} required>
              <option value="" disabled>
                Select a slot...
              </option>
              <option value="Tuesday 07 July_18:30-20:30">Tuesday 07 July @ 18:30-20:30</option>
              <option value="Thursday 09 July_18:30-20:30">Thursday 09 July @ 18:30-20:30</option>
              <option value="Saturday 11 July_17:30-19:30">Saturday 11 July @ 17:30-19:30</option>
              <option value="Sunday 12 July_17:30-19:30">Sunday 12 July @ 17:30-19:30</option>
              <option value="Thursday 16 July_18:30-20:30">Thursday 16 July @ 18:30-20:30</option>
              <option value="Saturday 18 July_17:30-19:30">Saturday 18 July @ 17:30-19:30</option>
              <option value="Sunday 19 July_17:30-19:30">Sunday 19 July @ 17:30-19:30</option>
              <option value="Saturday 25 July_17:30-19:30">Saturday 25 July @ 17:30-19:30</option>
              <option value="Sunday 26 July_17:30-19:30">Sunday 26 July @ 17:30-19:30</option>
              <option value="Tuesday 28 July_18:30-20:30">Tuesday 28 July @ 18:30-20:30</option>
            </PopupInput>
          </InputGroup>
        </InputRow>
      </PopupForm>
      <ReserveBtn type="submit" form="reservation-form" style={{ width: "25vh", height: "16vh", letterSpacing: "0.2vh" }}>
        Submit
      </ReserveBtn>
    </PopupOuter>
  );
};

export default DetailsPopup;
